<template>
  <div id="claim-type-list">
    <vs-row style="flex-wrap: wrap-reverse" v-if="enterpriseKind == 2">
      <vs-col vs-lg="9" vs-sm="12">
        <div>
          <div class="list-controller">
            <div class="search-input-area">
              <search-input
                placeholder="損害種類名"
                :onInputEnter="onSearchEnter"
              ></search-input>
            </div>
            <paging-navigation
              :startItemNumber="startItemNumber"
              :endItemNumber="endItemNumber"
              :totalItemNumber="totalItemNumber"
              :isPreviousActive="isPreviousPage"
              :isNextActive="isNextPage"
              :onPreviousClick="onPreviousPage"
              :onNextClick="onNextPage"
              :onSelectDisplayNumber="onSelectDisplayNumber"
            >
            </paging-navigation>
          </div>

          <hull-list
            :data="data"
            :columns="columns"
            :pagination="true"
            :displayItems="displayItems"
            :incrementSearch="false"
            :onClickEdit="openEditModal"
            :onClickDelete="openDeleteModal"
            :isSearchResultNoData="isSearchResultNoData"
            :noDataRegistered="noDataRegistered"
            :onClickLinkString="toClaimTemplate"
          >
            <template v-slot:isSearchResultNoData>
              <div class="list-message-label aisea-text-20-400-gray-black">
                検索条件に一致する損害種類が見つかりませんでした。
              </div>
            </template>
            <template v-slot:noDataRegistered>
              <div class="list-message-label aisea-text-20-400-gray-black">
                損害種類が登録されていません。
              </div>
              <common-button
                title="損害種類登録"
                icon="add"
                :click="clickAddClaimTypeButton"
              ></common-button>
            </template>
          </hull-list>

          <common-modal title="損種マスター登録" ref="EditModal">
            <template v-slot:contents>
              <div class="form-container">
                <common-text-box-step
                  class="step-form-item"
                  formLabel="損害種類名"
                  :required="true"
                  :deleteButton="false"
                  :value.sync="formClaimTypeName"
                ></common-text-box-step>
                <div class="form-scroll-area">
                  <common-text-box-step
                    class="step-form-item"
                    formLabel="ステップ1"
                    :required="true"
                    :deleteButton="false"
                    :value.sync="mandatoryStep"
                  ></common-text-box-step>
                  <common-text-box-step
                    class="step-form-item"
                    v-for="(step, index) in additionalSteps"
                    :key="index"
                    :formLabel="'ステップ' + (index + 2)"
                    :required="true"
                    :deleteButton="true"
                    :value.sync="additionalSteps[index]"
                    :onClickDelete="() => deleteStep(index)"
                  ></common-text-box-step>

                  <common-add-button
                    class="my-6 flex justify-center"
                    :click="addStep"
                    title="ステップ追加"
                    icon="PlusIcon"
                  ></common-add-button>
                </div>
                <div class="continually-add-check" v-if="isAddMode">
                  <vs-checkbox
                    class="checkbox"
                    v-model="isContinuallyAdd"
                    color="#48a0f4"
                    >続けて作成</vs-checkbox
                  >
                </div>

                <div class="button-area">
                  <common-button
                    class="button"
                    title="キャンセル"
                    :click="closeEditModal"
                    color="#BDBDBD"
                    text-color="#757575"
                    type="border"
                  ></common-button>
                  <common-button
                    class="button"
                    title="登録"
                    :click="isAddMode ? callAdd : callEdit"
                    :disabled="!isFormValidated"
                  ></common-button>
                </div>
              </div>
            </template>
          </common-modal>
          <common-modal title="" ref="DeleteModal">
            <template v-slot:contents>
              <div class="delete-container">
                損種を削除すると、紐付けた事故ページテンプレートも削除されます。ただし以前作成した事故ページや保存済の情報は削除されません。
                <div class="button-area">
                  <common-button
                    class="button"
                    title="キャンセル"
                    :click="closeDeleteModal"
                    color="#BDBDBD"
                    text-color="#757575"
                    type="border"
                  ></common-button>
                  <common-button
                    class="button"
                    title="削除"
                    :click="() => callDelete(selectedItemId)"
                  ></common-button>
                </div>
              </div>
            </template>
          </common-modal>
        </div>
      </vs-col>
      <vs-col class="right-widget-area" vs-lg="3" vs-sm="12">
        <hull-navigation-select
          class="mb-4"
          menuButtonLabel="メニュー"
          :menuItemOptions="getMenuItemOptions(this.$route.name)"
        >
        </hull-navigation-select>

        <common-button
          title="損害種類登録"
          icon="add"
          :click="clickAddClaimTypeButton"
        ></common-button>
        <claim-count-label
          itemLabel="損害種類登録数"
          :count="totalItemNumber"
          class="my-4"
        ></claim-count-label>
      </vs-col>
    </vs-row>
    <div v-else-if="enterpriseKind == 1">
      <no-access-label></no-access-label>
    </div>
  </div>
</template>

<script>
import HullList from "../components/molecules/HullList";
import SearchInput from "../components/molecules/SearchInput";
import PagingNavigation from "../components/molecules/PagingNavigation";
import CommonModal from "../components/organisms/CommonModal.vue";
import CommonButton from "../components/molecules/CommonButton.vue";
import CommonTextBoxStep from "../components/molecules/CommonTextBoxStep.vue";
import ClaimCountLabel from "../components/molecules/ClaimCountLabel.vue";
import HullNavigationSelect from "../components/molecules/HullNavigationSelect.vue";
import NoAccessLabel from "../components/organisms/NoAccessLabel.vue";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import moment from "moment";
import FireStoreService from "@/services/fireStoreService";
import CommonAddButton from "../components/molecules/CommonAddButton.vue";
const claimTypeRepository = AiseaApiFactory.get(
  "hullInsuranceEnterpriseClaimType"
);

import { HULL_INSURANCE_CLAIM_TYPE_STATUS_LABEL } from "@/config/const";
import { HullInsranceMixin } from "@/mixins";

export default {
  name: "T.ClaimTypeList",
  mixins: [HullInsranceMixin],
  components: {
    SearchInput,
    PagingNavigation,
    HullList,
    CommonModal,
    CommonButton,
    CommonTextBoxStep,
    ClaimCountLabel,
    HullNavigationSelect,
    NoAccessLabel,
    CommonAddButton,
  },
  data() {
    return {
      enterpriseKind: null,

      startItemNumber: 0,
      endItemNumber: 0,
      totalItemNumber: 0,
      currentPage: 0,
      pageSize: 10,

      isPreviousPage: false,
      isNextPage: false,

      displayItems: {
        number: 10,
      },
      columns: [
        {
          displayName: "テンプレートの登録状況",
          inputType: "status",
          key: "template_status",
          searchable: false,
        },
        {
          displayName: "損害種類名",
          inputType: "linkString",
          key: "claim_type_name",
          searchable: true,
        },
        {
          displayName: "ステップ",
          inputType: "string",
          key: "step",
          searchable: false,
        },
        {
          displayName: "更新日",
          inputType: "string",
          key: "update_date",
          searchable: false,
        },
      ],
      data: [
        /*
        {
          id: "4",
          claim_type_name: "PA（通常の修繕費）",
          step: "第一報/事故の状況確認/サーベイ",
          update_date: "2023/04/22",
          status: {
            label: "受付中",
            color: "EB5757",
          },
        },
        */
      ],

      searchKeyword: "",
      selectedItemId: null,
      mandatoryStep: "",
      additionalSteps: [],
      formClaimTypeName: "",
      editVersion: null,
      editStatus: null,
      isContinuallyAdd: false,
    };
  },
  async created() {
    this.enterpriseKind = await this.getEnterpriseKind();
    await this.initializeDisplayNumber();
    this.callFetch();
  },
  computed: {
    isFormValidated() {
      const allAdditionalStepNotEmpty = this.additionalSteps.every(element => {
        return element.trim().length > 0;
      });
      return (
        this.mandatoryStep.trim().length > 0 &&
        this.formClaimTypeName.length > 0 &&
        allAdditionalStepNotEmpty
      );
    },
    isSearchResultNoData() {
      return (
        this.searchKeyword != "" &&
        this.data.length == 0 &&
        this.currentPage == 0
      );
    },
    noDataRegistered() {
      return (
        this.searchKeyword == "" &&
        this.data.length == 0 &&
        this.currentPage == 0
      );
    },
    isEditMode() {
      return this.selectedItemId != null;
    },
    isAddMode() {
      return this.selectedItemId == null;
    },
  },
  methods: {
    async initializeDisplayNumber() {
      const res = await FireStoreService.getAccountSetting("claim_type_list");
      if (res && res.page_size) {
        this.pageSize = res.page_size;
      } else {
        this.pageSize = 10;
      }
    },
    saveDisplayNumberInFireStore() {
      FireStoreService.setAccountSetting("claim_type_list", {
        page_size: this.pageSize,
      });
    },
    addStep() {
      this.additionalSteps.push("");
    },
    deleteStep(index) {
      this.additionalSteps.splice(index, 1);
    },
    onSelectDisplayNumber(number) {
      this.pageSize = number;
      this.currentPage = 0;
      this.saveDisplayNumberInFireStore();
      this.callFetch();
    },
    onSearchEnter(searchKeyword) {
      this.searchKeyword = searchKeyword;
      this.currentPage = 0;
      this.callFetch();
    },
    clickAddClaimTypeButton() {
      this.selectedItemId = null;
      this.clearStepForm();
      this.$refs.EditModal.show();
    },
    clearStepForm() {
      this.mandatoryStep = "";
      this.additionalSteps.length = 0;
      this.formClaimTypeName = "";
    },
    async callAdd() {
      let steps = [this.mandatoryStep, ...this.additionalSteps];
      steps = steps.map(element => {
        return {
          name: element,
        };
      });

      const res = await claimTypeRepository.add({
        name: this.formClaimTypeName,
        steps: steps,
      });
      if (res.status == true) {
        this.$vs.notify({
          title: "損害種類を追加しました",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
        });
        this.clearStepForm();
        if (!this.isContinuallyAdd) {
          this.closeEditModal();
        }
        this.callFetch();
      } else if (res.code == 400) {
        this.$vs.notify({
          title: res.message,
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      } else {
        this.$vs.notify({
          title: "損害種類の追加に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    },
    async callFetch() {
      this.$vs.loading();
      const res = await claimTypeRepository.fetch({
        name: this.searchKeyword,
        page: this.currentPage,
        size: this.pageSize,
      });
      this.$vs.loading.close();
      if (res.status == true) {
        this.data = res.data.claim_types.map(element => {
          const stepString = element.claim_type_steps
            .map(step => {
              return step.name;
            })
            .join("/");
          const id = element.id;
          const name = element.name;
          const updateAt = element.updated_at;
          const status = element.status;
          const claimTypeSteps = element.claim_type_steps;
          const version = element.version;
          return {
            id: id,
            claim_type_name: name,
            step: stepString,
            claim_type_steps: claimTypeSteps,
            update_date: moment(updateAt)
              .local()
              .format("YYYY/MM/DD"),
            template_status: this.getStatusLabelColor(status),
            version: version,
          };
        });

        this.setPagigation(
          this.currentPage,
          res.data.total_pages,
          this.pageSize,
          res.data.claim_types.length,
          res.data.total_elements
        );
      } else {
        this.$vs.notify({
          title: "損種の取得に失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    },
    async callEdit() {
      const steps = JSON.parse(
        JSON.stringify([this.mandatoryStep, ...this.additionalSteps])
      ).map(element => {
        return { name: element };
      });
      const res = await claimTypeRepository.update(this.selectedItemId, {
        name: this.formClaimTypeName,
        steps: steps,
        status: this.editStatus.value,
        version: this.editVersion,
      });
      if (res.status == true) {
        this.$vs.notify({
          title: "損種を更新しました",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
        });
        this.clearStepForm();
        this.closeEditModal();
        this.callFetch();
      } else if (res.code == 400) {
        this.$vs.notify({
          title: res.message,
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      } else {
        this.$vs.notify({
          title: "損種の更新に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    },
    setPagigation(
      currentPage,
      totalPage,
      pageSize,
      displayItemNumber,
      totalItemNumber
    ) {
      this.startItemNumber = totalPage == 0 ? 0 : pageSize * currentPage + 1;
      this.endItemNumber =
        totalPage == 0 ? 0 : this.startItemNumber + displayItemNumber - 1;
      this.totalItemNumber = totalItemNumber;
      this.isNextPage = currentPage < totalPage - 1;
      this.isPreviousPage = currentPage > 0;

      this.currentPage = currentPage;
    },
    onPreviousPage() {
      this.currentPage--;
      this.callFetch();
    },
    onNextPage() {
      this.currentPage++;
      this.callFetch();
    },
    getStatusLabelColor(statusNumber) {
      return HULL_INSURANCE_CLAIM_TYPE_STATUS_LABEL[statusNumber];
    },
    async callDelete(id) {
      this.$vs.loading();
      const res = await claimTypeRepository.delete(id);
      this.$vs.loading.close();
      if (res.status == true) {
        this.$vs.notify({
          title: "損種を削除しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
        });
      } else {
        this.$vs.notify({
          title: "損種の取得に失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
      this.closeDeleteModal();
      this.currentPage = 0;
      this.callFetch();
    },
    openEditModal(id) {
      this.selectedItemId = id;
      if (id != null) {
        const found = this.data.find(element => element.id == id);
        this.setEditModalForm(
          found.claim_type_name,
          found.claim_type_steps,
          found.version,
          found.template_status
        );
      }
      this.$refs.EditModal.show();
    },
    setEditModalForm(claimTypeName, claimTypeSteps, version, templateStatus) {
      this.clearStepForm();

      this.formClaimTypeName = claimTypeName;
      if (claimTypeSteps != null) {
        if (claimTypeSteps.length >= 1) {
          this.mandatoryStep = claimTypeSteps[0].name
            ? claimTypeSteps[0].name
            : "";
        }

        if (claimTypeSteps.length >= 2) {
          for (let i = 1;i < claimTypeSteps.length;i++) {
            this.additionalSteps.push(claimTypeSteps[i].name);
          }
        }
      }

      this.editVersion = version;
      this.editStatus = templateStatus;
    },
    openDeleteModal(id) {
      this.selectedItemId = id;
      this.$refs.DeleteModal.show();
    },
    closeEditModal() {
      this.clearStepForm();
      this.$refs.EditModal.close();
    },
    closeDeleteModal() {
      this.$refs.DeleteModal.close();
    },
    toClaimTemplate(id) {
      this.$router.push({
        name: `hull-insurance-claim-template`,
        params: { id },
      });
    },
  },
};
</script>

<style lang="scss">
#claim-type-list {
  .list-controller {
    display: flex;
    margin-bottom: 20px;
    .search-input-area {
      flex-grow: 1;
    }
  }
  .right-widget-area {
    padding-left: 20px;
    max-width: 300px;
  }
  .list-message-label {
    margin: 10px;
  }
}
.form-container {
  width: 414px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  .add-step-button {
    width: fit-content;
    display: flex;
    cursor: pointer;
    padding: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .step-form-item {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .continually-add-check {
    margin-top: 10px;
    margin-bottom: 10px;
    width: 100%;
    .checkbox {
      width: fit-content;
    }
  }
  .button-area {
    display: flex;
    justify-content: space-between;
    width: 320px;
    margin-top: 20px;
    margin-bottom: 10px;
    .button {
      width: 140px;
    }
  }
  .form-scroll-area {
    margin-top: 10px;
    margin-bottom: 15px;
    max-height: 400px;
    width: 100%;
    overflow-y: auto;
  }
}
.delete-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  .button-area {
    display: flex;
    justify-content: space-between;
    width: 320px;
    margin-top: 20px;
    margin-bottom: 10px;
    .button {
      width: 140px;
    }
  }
}
</style>
